


























import {
  defineComponent,
  reactive,
  toRefs,
  computed,
} from '@vue/composition-api';
import sl from '@/serviceLocator';

export default defineComponent({
  setup() {
    const store = sl.get('store');

    const state = reactive({
      routes: computed(() => [
        {
          label: 'Groups',
          path: '/admin/groups',
        },
        {
          label: 'Public Denylist',
          path: '/admin/denylist/texts',
        },
        {
          label: 'Quarantined Texts',
          path: '/admin/quarantine',
        },
        {
          label: 'Error Log',
          path: '/admin/errors',
          showIndicator: store.getters.displayAdminBadge.error,
        },
        {
          label: 'Comments',
          path: '/admin/comments',
          showIndicator: store.getters.displayAdminBadge.comments,
        },
        {
          label: 'Text Drafts',
          path: '/admin/drafts',
        },
        {
          label: 'Properties Taxonomy',
          path: '/admin/properties',
        },
        { label: 'Site Analytics', path: '/admin/analytics' },
        {
          label: 'Admin Settings',
          path: '/admin/settings',
        },
      ]),
    });

    return {
      ...toRefs(state),
    };
  },
});
